import { ApplicationState } from '@/platform/ApplicationState';
import { Visa } from '@/presenters/Visa';
import { IGetters } from './IGetters';
import { IState } from './IState';
import { Country } from '@/presenters/Country';

export class Getters implements IGetters {
	private readonly state: IState;

	public constructor(state: IState) {
		this.state = state;
	}

	public getApplicationState(): ApplicationState {
		return this.state.applicationState;
	}

	public getOriginCountry(): Country | null {
		return this.state.originCountryId ? new Country(this.state.originCountryId) : null;
	}

	public getDestinationCountry(): Country | null {
		return this.state.destinationCountryId ? new Country(this.state.destinationCountryId) : null;
	}

	public getOriginCountryId(): string | null {
		return this.state.originCountryId;
	}

	public getDestinationCountryId(): string | null {
		return this.state.destinationCountryId;
	}

	public getVisa(): Visa | null {
		return this.state.visa;
	}
}
